module.exports = __webpack_public_path__ + "static/media/5fe5587d-6be9-43a7-a4c6-229d498d7cf2 2.74919999.png";